import { useTranslation } from 'next-i18next/pages';

import CardWithVideo from '@pflegia/ui/shared/card-with-video/CardWithVideo';
import VideoButton from '@pflegia/ui/shared/video-button';

import { Perk } from '@domains/landing-page/constants/praxia-employer-landing-page';

import Headline from '../headline/Headline';

export interface VideoObject {
  thumbnail: string;
  id: string;
}
export interface HowItWorksProps {
  employerLayout?: boolean;
  video: VideoObject;
  perks?: Perk[];
  alt?: string;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ employerLayout, video, perks, alt }) => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'howItWorks.employer.perks' });
  return (
    <div className='flex flex-col items-center'>
      <Headline i18nKey={`landingPage:howItWorks.${employerLayout ? 'employer' : 'guest'}.title`} />
      <VideoButton imgSrc={video.thumbnail} videoId={video.id} className='aspect-video' alt={alt} />
      {perks?.length && (
        <div className='mt-16 grid w-full auto-rows-max grid-cols-1 gap-y-12'>
          {perks.map(({ name, videoId, imgSrc }, index) => (
            <CardWithVideo
              key={name}
              title={t(`${name}.title`)}
              description={t(`${name}.description`)}
              videoId={videoId}
              textOnTheLeft={Boolean(index % 2)}
              imgSrc={imgSrc}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HowItWorks;
